import type { AntdIconProps } from './_type';

import { memo } from 'react';

import { SyncOutlined } from '@ant-design/icons';

import { default as classes } from './_.module.scss';
import { useAntdIcon } from './_hook';

export default memo(({ name, ...props }: AntdIconProps) => {
  /** useAntdIcon */
  const { states } = useAntdIcon(name);

  /** states */
  const { Component } = states;

  /** return */
  return Component ? <Component {...props} /> : <SyncOutlined className={classes.load} />;
});
